import { Fragment, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import CustomerContext from "@/stores/customer-context";
import { utmSchema, staffCodeSchema } from "@/helpers/schema_validation";
import { useErrorHandler } from "react-error-boundary";
export function QueryParamsMiddleWare({ children }) {
  const customerCtx = useContext(CustomerContext);
  const handleError = useErrorHandler();
  const router = useRouter();
  const utmTracking = async (params) => {    
    const utm = await utmSchema()
      .validate(params)
      .catch((err) => {
        console.log(err.message);
        throw new Error(err.message);
      });
    const utmTransformed = {
      utmSource: utm["utm_source"],
      utmMedium: utm["utm_medium"],
      utmCampaign: utm["utm_campaign"] || "",
      utmTerm: utm["utm_term"] || "",
    };
    const result = await customerCtx.setUtm(utmTransformed);
  };
  const staffCodeTracking = async (params) => {
    const staffCode = params["s"];
    const result = await customerCtx.setStaffCode(staffCode);
  };
  useEffect(() => {
    const { query } = router;
    if (utmSchema().isValidSync(query)) {
      utmTracking(query).then(() => {}, handleError);
    }
    if (staffCodeSchema().isValidSync(query)) {
      staffCodeTracking(query);
    }
  }, [router]);
  return <Fragment>{children}</Fragment>;
}
